import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'flx-checkbox',
	templateUrl: './checkbox.component.html',
	styleUrls: ['./checkbox.component.scss'],
	// encapsulation: ViewEncapsulation.Emulated,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => FLXCheckboxComponent),
			multi: true
		}
	]
})
export class FLXCheckboxComponent implements ControlValueAccessor {
	@ViewChild('checkBoxContainer', { static: true }) checkBoxContainer!: ElementRef<HTMLInputElement>;

	private onChangeFn: (value: boolean) => void = () => {};
	private onTouchedFn: () => void = () => {};

	private _checked = false;
	private _tabIndex = -1;
	private _margin = '0.5rem';
	private _padding = '0 0 0 1.4rem';

	public styleClasses: {
		checkedClass?: string;
		disabledClass?: string;
		tabIndexClass?: string;
	} = {};
	// checkedClass = '';
	// disabledClass = '';
	// tabIndexClass = '';

	// Button checked

	@Input()
	set checked(checked: boolean) {
		this._checked = checked;
	}
	get checked() {
		return this._checked;
	}

	@Output()
	checkChanged = new EventEmitter();

	// Checkbox disabled

	@Input()
	set disabled(disabled: boolean) {
		// `setDisabledState` can be called before the ViewChild is ready in some cases
		if (this.checkBoxContainer?.nativeElement) {
			this.checkBoxContainer.nativeElement.disabled = disabled;
		}
	}
	get disabled() {
		return this.checkBoxContainer?.nativeElement?.disabled ?? false;
	}

	//  tabIndex
	@Input()
	set tabIndex(tabIndex: number) {}
	get tabIndex() {
		return this._tabIndex;
	}

	@Input() id: string;

	@Input()
	set margin(marval: string) {
		this._margin = marval || '1rem';
	}
	get margin() {
		return this._margin;
	}
	@Input()
	set padding(padval: string) {
		this._padding = padval || '0 0 0 1.4rem';
	}
	get padding() {
		return this._padding;
	}
	get arrClasses() {
		return Object.values(this.styleClasses);
	}

	handleChange(value: boolean) {
		// Update local UI state and notify the form control
		this.checked = value;
		this.onChangeFn(value);
		this.checkChanged.emit(value);
	}

	handleBlur() {
		this.onTouchedFn();
	}

	writeValue(value: boolean): void {
		// Keep UI in sync with the form value
		this.checked = !!value;
	}
	registerOnChange(fn: any): void {
		this.onChangeFn = fn;
	}
	registerOnTouched(fn: any): void {
		this.onTouchedFn = fn;
	}
	setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}
}
